// src/components/Team.jsx
import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import ResponsiveImage from './ResponsiveImage';
import { useSiteData } from '../context/SiteDataContext';
import { getImageUrl } from '../lib/supabase';

function Team() {
  const { team, loading } = useSiteData();
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 992);

  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth >= 992);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const Container = isDesktop ? motion.div : 'div';
  const motionProps = isDesktop ? {
    initial: { opacity: 0, y: 50 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true, amount: 0.01 },
    transition: { duration: 1, ease: 'easeOut' }
  } : {};

  const members = team ?? [];

  return (
    <section
      id="team"
      className="page-section bg-light modern-team py-5"
      style={{
        background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
        position: 'relative'
      }}
    >
      <div className="position-absolute top-0 start-0 w-100 h-100 overflow-hidden" style={{ zIndex: 1 }}>
        <div className="position-absolute rounded-circle"
          style={{
            width: '180px', height: '180px',
            background: 'linear-gradient(45deg, rgba(66, 89, 168, 0.08), rgba(46, 141, 215, 0.08))',
            top: '20%', left: '10%', filter: 'blur(25px)'
          }}
        />
        <div className="position-absolute rounded-circle"
          style={{
            width: '220px', height: '220px',
            background: 'linear-gradient(45deg, rgba(46, 141, 215, 0.06), rgba(66, 89, 168, 0.06))',
            bottom: '10%', right: '15%', filter: 'blur(30px)'
          }}
        />
      </div>

      <Container className="container position-relative" style={{ zIndex: 2 }} {...motionProps}>
        <div className="text-center mb-5">
          <h2
            className="section-heading text-uppercase responsive-heading fw-bold mb-4"
            style={{ color: '#4259A8', fontSize: '2.5rem', letterSpacing: '2px' }}
          >
            Naš tim
          </h2>
          <div className="mx-auto mb-4"
            style={{ width: '80px', height: '4px', background: 'linear-gradient(90deg, #4259A8, #2E8DD7)', borderRadius: '2px' }}
          />
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <p className="text-muted lead" style={{ fontSize: '1.1rem', lineHeight: '1.8', color: '#495057' }}>
                Stručni tim Akriona čine ljudi koji dijele prije svega jednu temeljnu vrijednost: Brigu o
                čovjeku. Naši ortopedi, fizioterapeuti i stručni suradnici donose bogato iskustvo, ali još
                važnije – donose strpljenje, empatiju i stalnu želju za učenjem.
              </p>
            </div>
          </div>
        </div>

        {loading ? (
          <div className="text-center py-5">Učitavanje...</div>
        ) : (
          <div className="row g-4 justify-content-center">
            {members.map((member, index) => (
              <div
                key={member.slug}
                className={`col-lg-4 col-md-6 ${index === members.length - 1 ? 'mx-lg-auto' : ''}`}
              >
                <Link to={`/team/${member.slug}`} style={{ textDecoration: 'none' }}>
                  <div
                    className="team-card"
                    style={{
                      backgroundColor: '#fff',
                      overflow: 'hidden',
                      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                      transition: 'all 0.3s ease',
                      cursor: 'pointer'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-8px)';
                      e.currentTarget.style.boxShadow = '0 8px 20px rgba(66, 89, 168, 0.15)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.1)';
                    }}
                  >
                    <div style={{ width: '100%', height: '300px', overflow: 'hidden', backgroundColor: '#f8f9fa' }}>
                      <ResponsiveImage
                        src={getImageUrl(member.image)}
                        sizes="(max-width: 768px) 100vw, (max-width: 992px) 50vw, 33vw"
                        alt={member.name}
                        objectFit="cover"
                        objectPosition="center top"
                        style={{ width: '100%', height: '100%' }}
                      />
                    </div>
                    <div style={{ padding: '1.5rem', textAlign: 'center' }}>
                      <h4 style={{ color: '#212529', fontSize: '1.1rem', fontWeight: '600', marginBottom: '0.5rem' }}>
                        {member.name}
                      </h4>
                      <p style={{ color: '#6c757d', fontSize: '0.95rem', marginBottom: 0 }}>
                        {member.role}
                      </p>
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        )}
      </Container>
    </section>
  );
}

export default Team;